import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import moment from 'moment';
import { Result } from '../../../common-models/Result';
import { DanfePackingData } from '../../../models/DanfePackingData';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetDanfePackingLabelInput } from './GetDanfePackingLabelInput';
import { CallbackResultType } from '../../../enums/CallbackResultType';

export class GetDanfePackingLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetDanfePackingLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetDanfePackingLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/danfe-packing-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfPackingDanfe}.zpl`);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }

  zipFileHandle = (input: GetDanfePackingLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetDanfePackingLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/danfe-packing-label/file-zip`,
      input
    ).then(result => {
      const currentDate = moment().format('YYYY-MM-DD');
      this.report.download(result, `EtiquetasDanfe-${currentDate}.zip`);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }

  pdfHandle = (input: GetDanfePackingLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetDanfePackingLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/danfe-packing-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }

  dataHandle = (input: GetDanfePackingLabelInput): Promise<Result<DanfePackingData[]> | null> => {
    const promise = this.http.post<Result<DanfePackingData[]>, GetDanfePackingLabelInput>(`${this.baseUrlSislogV2Api}/v2/danfe-packing-label/data`, input);
    return promise;
  }
}
